import React from "react"
import { PageHero } from "../ui/page-hero"

export function ContactHero() {
  return (
    <PageHero
      title="Get in Touch"
      description="Ready to build AI that actually understands your organisation? Let's talk about turning institutional knowledge into lasting capability."
      backgroundImage="/images/backgrounds/flickr-2440831907.jpg"
      backgroundAlt="Contact us"
    />
  )
}